<template lang="pug">
  v-container.nopadding
    div#app
      l-map(
        :zoom.sync="zoom"
        :center="center"
        ref="deviceMap"
        @update:bounds="updateBounds"
      )
        l-tile-layer(:url="url")
        l-marker(
          v-for="marker in markers"
          :key="marker.id"
          :icon="marker.icon"
          :title="marker.name"
          :lat-lng="marker.position"
          @move="updateMarkerPosition($event, marker.id)"
          :draggable="markerDraggable"
        )
</template>

<script>
import { mapGetters } from "vuex";
import L from "leaflet";
import "leaflet.heat";
import { LMap, LMarker, LTileLayer } from "vue2-leaflet";
import API from "@/api";
// import generatePoints from "@/utilities/randomPoints";

delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png")
});

const origin = { lat: 50.868587, lng: 9.707019 };

export default {
  name: "Map",
  components: {
    LMap,
    LMarker,
    LTileLayer
  },
  data() {
    return {
      markerDraggable: true,
      zoom: 15,
      center: L.latLng(origin.lat, origin.lng),
      url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
      bounds: false,
      lastRequestBounds: {},
      latLngDiff: {
        lat: 0.0060335,
        lng: 0.0822255
      },
      heatmap: null
    };
  },
  mounted() {
    let myPromise = new Promise((resolve, reject) => {
      this.bounds = this.map.getBounds();
      return resolve("Resolved!");
    });
    myPromise
      .then(
        function(success) {
          this.$store.dispatch("SET_MAP_BOUNDS", this.bounds);
          // let [neLat, neLng] = [
          //   this.bounds._northEast.lat,
          //   this.bounds._northEast.lng
          // ];
          // let [swLat, swLng] = [
          //   this.bounds._southWest.lat,
          //   this.bounds._southWest.lng
          // ];
          // this.$store.dispatch(
          //   "SET_POINTS",
          //   generatePoints(neLat, neLng, swLat, swLng, 10000)
          // );
        }.bind(this)
      )
      .catch(err => {
        console.log(err);
      });
  },
  watch: {
    heatmapVisible(state) {
      if (state) {
        let mappedPoints = this.$store.getters.visiblePoints.map(o => {
          return [o.lat, o.lng, o.value];
        });

        this.heatmap = L.heatLayer(mappedPoints);
        this.heatmap.addTo(this.map);
      } else {
        this.map.removeLayer(this.heatmap);
      }
    }
  },
  computed: {
    ...mapGetters(["heatmapVisible", "markers", "reviewDialog"]),
    map() {
      return this.$refs.deviceMap.mapObject;
    },
    markerVisible() {
      return this.$store.state.showMarker;
    },
    choroplethVisible() {
      return this.geoJSON && this.measurements && !this.showChoropleth;
    },
    showChoropleth: {
      get() {
        return this.$store.state.showChoropleth;
      }
    },
    geoJSON: {
      get() {
        return this.$store.state.geoJSON;
      }
    },
    measurements: {
      get() {
        return this.$store.state.measurements;
      }
    },
    maxBounds() {
      return {
        _northEast: L.latLng(
          origin.lat + this.latLngDiff.lat,
          origin.lng - this.latLngDiff.lng
        ),
        _southWest: L.latLng(
          origin.lat - this.latLngDiff.lat,
          origin.lng + this.latLngDiff.lng
        )
      };
    },
    format_datetime(date, time) {
      return `${date} ${time}`;
    },
    getBounds() {
      const bounds = this.$store.state.mapBounds;
      return {
        latStart: bounds.getSouthEast().lat,
        lngStart: bounds.getNorthWest().lng,
        latStop: bounds.getNorthWest().lat,
        lngStop: bounds.getSouthEast().lng
      };
    },
    calculateBins() {
      const dLng = Math.abs(
        this.bounds.getNorthWest().lng - this.bounds.getSouthEast().lng
      );
      return dLng / 20;
    }
  },
  methods: {
    updateMarkerPosition: function(event, id) {
      this.$store.dispatch("SET_MARKER_POSITION", {
        id: id,
        latLng: event.latlng
      });
    },
    updateBounds: function() {
      const bounds = this.map.getBounds();
      const northEast = bounds._northEast;
      const southWest = bounds._southWest;

      this.bounds._northEast.lat = northEast.lat;
      this.bounds._southWest.lat = southWest.lat;
      this.bounds._northEast.lng = northEast.lng;
      this.bounds._southWest.lng = southWest.lng;

      const mapCenter = this.map.getCenter();

      this.$store.dispatch("SET_MAP_BOUNDS", this.bounds);
      this.$store.dispatch("SET_MAP_CENTER", mapCenter);
      this.loadData();
    },
    getRequestURL: function() {
      let { latStart, lngStart, latStop, lngStop } = this.getBounds;
      let latStep = this.calculateBins;
      let lngStep = this.calculateBins;
      // let from = this.format_datetime(this.startDate, this.startTime)
      // let to = this.format_datetime(this.endDate, this.endTime)
      let url = `getMapObjects?latStart=${latStart}&lngStart=${lngStart}&latStop=${latStop}&lngStop=${lngStop}&latStep=${latStep}&lngStep=${lngStep}`;
      // if (this.$store.state.showMarker) {
      //   const treeLat = this.$store.state.markerPosition[0]
      //   const treeLng = this.$store.state.markerPosition[1]
      //   url = `getMapObjects?latStart=${latStart}&lngStart=${lngStart}&latStop=${latStop}&lngStop=${lngStop}&latStep=${latStep}&lngStep=${lngStep}&treeLat=${treeLat}&treeLng=${treeLng}`
      // }
      return url;
    },
    makeAPICall: function() {
      let API_URL = this.getRequestURL();
      API.get(API_URL)
        .then(response => {
          this.$store.dispatch("SET_GEOJSON", response.data);
          const measurements = response.data.features.map(function(obj) {
            return obj.properties;
          });
          this.$store.dispatch("SET_MEASUREMENT", measurements);
          // this.$store.dispatch('TOGGLE_FILTER_BUTTON')
        })
        .catch(e => {
          this.$emit(
            "apiError",
            "Could not connect to the API. Try again later."
          );
        });
    },
    loadData: function() {
      if (
        !this.$store.state.showChoropleth &&
        this.$store.state.measurements &&
        this.$store.state.geoJSON
      ) {
        this.makeAPICall();
      }
    }
  }
};</script>


<style>
#app {
  height: 100%;
  width: 100%;
  z-index: 0;
}
.nopadding {
  height: 100%;
  margin: 0;
  max-width: 100%;
  padding: 0;
  width: 100%;
  z-index: 0;
}
</style>
